// extracted by mini-css-extract-plugin
module.exports = {"homeCollectionList":"HomeCollectionList_homeCollectionList__qrloA"};